module.exports = __webpack_public_path__ + "static/media/briefcase (2).330f7b3c.svg";